import React from 'react'
import { 
    Button
  } from '@material-ui/core';
  
const styles = {
    button: {
      margin: 8,
      backgroundColor: "black",
      color: "white"
    }
  };
const LeadsTransferButton = props => {
  return <Button color="secondary" variant="contained" onClick={props.addClick} style={styles.button}>Transfer Lead to New Dealer</Button>
}

export default LeadsTransferButton